<template>
  <router-view></router-view>
</template>

<script>
/**
 Componente principal que renderiza la vista principal de la aplicación.
 @vue/component
 @name MainComponent
 @template <router-view></router-view>
 */
import {watch} from 'vue';
import {useAuth} from '@/components/auth/store/composables';
import {useRoute, useRouter} from "vue-router";
import Swal from 'sweetalert2';

export default {
  name: "MainComponent",
  /**
   Configura la función checkAuthStatus desde useAuth, y las instancias de router y route desde vue-router.
   @function
   @name setup
   @async
   @returns {object} - Objeto con las variables router y route.
   */
  async setup() {
    const {checkAuthStatus} = useAuth();
    const router = useRouter();
    const route = useRoute();
    /**
     * Observa cambios en el nombre de la ruta actual y ejecuta `checkAuthStatus` para verificar el estado de autenticación.
     * Si el usuario no está autenticado y no se encuentra en la ruta de recuperación de contraseña, se redirige al inicio.
     * Si el usuario está autenticado y se encuentra en la página de inicio o de recuperación de contraseña, se redirige a la página principal.
     */
    watch(() => route.name, async () => {
      const ruta_actual = router.currentRoute.value.path;
      if (ruta_actual === "/verificacion-2fa") return;
      if (sessionStorage.getItem('tempToken')) return;

      await checkAuthStatus().then(async (status) => {
        if (!status['ok'] && ruta_actual !== "/recuperarContrasena" && !ruta_actual.includes("/recuperarContrasena_2/")) {
          if (status['statusCode']) {
            Swal.fire({
              icon: 'warning',
              title: 'Atención!',
              text: status.message + '\n' + ' Porfavor comuniquese con el administrador.',
            })
          }
          await router.push('/');
        } else if (status['ok'] && ['/', '/recuperarContrasena'].includes(ruta_actual)) {
          await router.push('/inicio');
        }
      })
    });
  }
};
</script>